<template>
  <div class="row full-height">
    <div class="col-xs-12 col-sm-12 col-lg-12 col-xl-12 full-height">
      <div
        class="image-wrapper"
        v-if="!activeItem"
      >
        <div class="active-empty-state">
          <img :src="emptyStateSrc">
          Please select an element to edit
        </div>
      </div>
      <drag-item-edit
        v-else
        :limitEditing="limitEditing"
        :editorName="editorName"
        @delete="deleteElement"
        @input="editElement"
      />
    </div>
  </div>
</template>
<script>
import DragItemEdit from '@/components/helpers/DragNDrop/DragItemEdit'

let whitelistedAttributes = [
  'name',
  'label',
  'title',
  'content',
  'required',
  'element_type',
  'placeholder',
  'class'
]

export default {
  props: {
    limitEditing: {
      type: Boolean,
      default: false
    },
    editorName: {
      type: String
    }
  },
  components: {
    DragItemEdit
  },
  computed: {
    activeItem() {
      let item = this.$store.getters.getDragEditorActiveItem
      if (Object.keys(item).length === 0) {
        return false
      }
      return true
    },
    emptyStateSrc() {
      return require('@/assets/forms_empty.svg')
    }
  },
  methods: {
    deleteElement(item) {
      this.$emit('delete', item)
    },
    editElement(element) {
      this.$emit('edit', element)
    }
  }
}
</script>
<style lang="sass" scoped>
.image-wrapper
  position: relative
  height: 100%
  .active-empty-state
    display: flex
    flex-direction: column
    align-items: center
    position: absolute
    top: 15%
    left: 0
    right: 0
    margin: auto
</style>



// WEBPACK FOOTER //
// DragActiveItemContainer.vue?05ebb7e0